import { JSONSchemaType } from 'ajv'

export interface IEmailFormData {
  id: string
  identifier: string
  title: string
  useLayout: boolean
  template: string
  variables: string
  status: string
  howLongInDays: number
}

const EmailSchema: JSONSchemaType<IEmailFormData> = {
  type: 'object',
  properties: {
    identifier: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório.',
    },
    title: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório.',
    },
    useLayout: {
      type: 'boolean',
      default: false,
    },
    template: {
      type: 'string',
    },
    variables: {
      type: 'string',
    },
    status: {
      type: 'string',
    },
    howLongInDays: {
      type: 'number',
      default: 0,
    },
    id: {
      type: 'string',
    },
  },
  required: ['identifier', 'title', 'template'],
  additionalProperties: false,
}

export default EmailSchema
